export const COOKIE_TASIX_STATUS = '_cr_tsx' as const;
